/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impersonation_StopInputs */



/**
* | output |
* | --- |
* | "Stop" |
*
* @param {Impersonation_StopInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const impersonation_stop = /** @type {((inputs?: Impersonation_StopInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impersonation_StopInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Stop")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Arrêter")
	return /** @type {LocalizedString} */ ("Stop")
});